import { Component, Input, OnInit } from '@angular/core';
import { OCPPChargepoint } from '../../../../api/chargepoints-api.service';
import { CopiableInfoComponent } from '../../../../elements/copiable-info/copiable-info.component';
@Component({
  selector: 'app-ocpp-vendor-info',
  templateUrl: './ocpp-vendor-info.component.html',
  styleUrls: ['./ocpp-vendor-info.component.scss'],
  imports: [CopiableInfoComponent]
})
export class OcppVendorInfoComponent implements OnInit {

  @Input() chargepoint?: OCPPChargepoint;

  constructor() { }

  ngOnInit() {
  }
}
